// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hbfq","toggle":"styles_toggle__2dl1W","preview":"styles_preview__1v2r5"};